import React from "react";
import { ArrowBackOutline, ArrowForwardOutline, ArrowBackCircle } from 'react-ionicons'
import HCPs from "./HCPs"
import constantURI from "../URI"
import _post from "../Functions/Post"
import stylesMed from "./stylesMed"
import { Modal } from 'react-bootstrap';
import Authenticate from "../Functions/MedRepAuthenticate"

function timeStringToFloat(time) {
    var hoursMinutes = time.split(/[.:]/);
    var hours = parseInt(hoursMinutes[0], 10);
    var minutes = hoursMinutes[1] ? parseInt(hoursMinutes[1], 10) : 0;
    return hours + minutes / 60;
}

export default class AddRoute extends React.Component {

    constructor() {
        super();
        this.state = {
            date: "",
            dateISO: "",
            checked: [],
            HCPs: [],
            rep: "",
            visitsCount: 0,
            USVisits: [],
            USPvisits: [],
            disableSave: false,
            disableSync: false,
            showAlert: false,
            cancelReason: "",
            loading: false,
            nextPrevDate: false,
            checkedCopy: [],
            token: "",
            specialRequest: [],
            currentRep: [],
            checkedIndex: [],
            expectedTime: [],
            enterloop: false,
            isDaily: false,
            isWeekly: false,
            dayCount: 0,
            isNextOrPrev: false,
            authenticate: false,
            alertUndefined: false
        }
    }

    async componentDidMount() {
        await Authenticate().then((response) => { this.setState({ authenticate: response }) });
        const RouteDate = localStorage.getItem('RouteDate');
        const RouteDate2 = localStorage.getItem('RouteDate2');
        const clients = localStorage.getItem('HCPs');
        const user = localStorage.getItem('User');
        const visitsCount = localStorage.getItem('UnsyncedPlannedVisitsCount');
        const uspvisits = localStorage.getItem('UnsyncedPlannedVisits');
        const checkedDoctors = localStorage.getItem('CheckedDoctors');
        const specialRequest = localStorage.getItem('SpecialRequest');
        const expectedTime = localStorage.getItem('ExpectedTime');
        const token = localStorage.getItem('Token');
        const isDaily = localStorage.getItem('Daily');
        const isWeekly = localStorage.getItem('Weekly');
        await this.setState({
            date: JSON.parse(RouteDate), dateISO: JSON.parse(RouteDate2), HCPs: JSON.parse(clients), rep: JSON.parse(user), token: JSON.parse(token),
            visitsCount: (visitsCount === "null") ? 0 : JSON.parse(visitsCount), USPvisits: (uspvisits === "null") ? [] : JSON.parse(uspvisits), checked: JSON.parse(checkedDoctors), checkedCopy: JSON.parse(checkedDoctors),
            specialRequest: JSON.parse(specialRequest), expectedTime: JSON.parse(expectedTime), isDaily: JSON.parse(isDaily), isWeekly: JSON.parse(isWeekly)
        });

        if (specialRequest === undefined || specialRequest == null) {
            localStorage.setItem('SpecialRequest', JSON.stringify([]));
            this.setState({ specialRequest: [] });
        }
        if (expectedTime === undefined || specialRequest == null) {
            localStorage.setItem('ExpectedTime', JSON.stringify([]));
            this.setState({ expectedTime: [] });
        }

        const readURL = constantURI() + "odooController/MedRepRead";
        const rep = {
            "jsonrpc": "2.0",
            "params": {
                "method": "search_read",
                "model": "res.partner",
                "args": [],
                "kwargs": {
                    "fields": ["name"],
                    "domain": [["name", "=", this.state.rep]]
                }
            },
            "token": this.state.token
        }
        const clientsBody = {
            jsonrpc: "2.0",
            params: {
                method: "search_read",
                model: "res.partner",
                args: [],
                kwargs: {
                    fields: ["name", "street", "phone", "potential", "cf", "state_id", "x_specialty_id", "clienttype", "x_month_visits"],
                    domain: [["x_repuser", "=", this.state.user]]
                }
            },
            "token": this.state.token
        }
        if (this.state.authenticate) {
            await _post(readURL, rep).then((response) => {
                return response.json().then(async (data) => {
                    if (data.result !== undefined) {
                        this.setState({ currentRep: data.result })
                        localStorage.setItem('UserDetail', JSON.stringify(this.state.currentRep));
                    }
                    else {
                        this.setState({ alertUndefined: true });
                    }
                })
            })
            await _post(readURL, clientsBody).then((response) => {
                return response.json().then((data) => {
                    if (data.result !== undefined) {
                        this.setState({ clients: data.result })
                        localStorage.setItem('HCPs', JSON.stringify(this.state.clients));
                    }
                    else {
                        this.setState({ alertUndefined: true });
                    }
                })
            })
        }
        else {
            const currentRep = localStorage.getItem("UserDetail");
            const clients = localStorage.getItem('HCPs');
            this.setState({ currentRep: JSON.parse(currentRep), clients: JSON.parse(clients) });
        }
    }

    onSave = async () => {
        await this.setState({ disableSave: true });
        await Authenticate().then((response) => { this.setState({ authenticate: response }) });
        if (!this.state.isDaily && this.state.isWeekly && this.state.dayCount < 5 && !this.state.isNextOrPrev) {
            alert("You need to schedule for the week!");
        }
        else if (!this.state.isWeekly && !this.state.isDaily && this.state.dayCount < 20 && !this.state.isNextOrPrev) {
            alert("You need to schedule for the month!");
        }
        else {
            const checkedDoctors = await localStorage.getItem('CheckedDoctors');
            const checkedIndex = await localStorage.getItem('CheckedDoctorsIndex');
            const specialRequest = localStorage.getItem('SpecialRequest');
            const expectedTime = localStorage.getItem('ExpectedTime');
            await this.setState({
                checked: JSON.parse(checkedDoctors), specialRequest: JSON.parse(specialRequest),
                checkedIndex: JSON.parse(checkedIndex), expectedTime: JSON.parse(expectedTime)
            });


            if (this.state.checked.length !== 0) {
                const d = new Date();
                d.setDate(d.getDate());
                var visits = (this.state.USPvisits === null || this.state.USPvisits === []) ? [] : this.state.USPvisits;
                const createVisitURL = constantURI() + "OdooController/CreateVisit"
                await this.state.checked.forEach(async (item, index, arr) => {
                    if (item !== null && item !== false && this.state.checkedCopy[index] !== true) {
                        this.setState({ enterloop: true });
                        await this.state.HCPs.map(async (client, clientIndex) => {
                            if (index === client.id) {
                                const visitBody = {
                                    jsonrpc: "2.0",
                                    params: {
                                        method: "create",
                                        model: "calendar.event",
                                        args: [
                                            {
                                                name: this.state.HCPs[clientIndex].name + "-" + this.state.HCPs[clientIndex].state_id[1] + " (" + this.state.rep + ")",
                                                start: this.state.dateISO,
                                                start_date: this.state.dateISO,
                                                start_datetime: this.state.dateISO + " " + d.toISOString().substring(11, 19),
                                                stop: this.state.dateISO,
                                                stop_date: this.state.dateISO,
                                                stop_datetime: this.state.dateISO + " " + d.toISOString().substring(11, 19),
                                                x_specialrequest_to_delivery: (this.state.specialRequest[index] != null) ? this.state.specialRequest[index] : null,
                                                expected_time_for_visit: (this.state.expectedTime[index] != null) ? timeStringToFloat(this.state.expectedTime[index]) : null,
                                                duration: 0.00,
                                                x_status: "0",
                                                partner_ids: [this.state.HCPs[clientIndex].id, this.state.currentRep[0].id]
                                            }
                                        ],
                                        "kwargs": {}
                                    },
                                    "token": this.state.token
                                }
                                if (this.state.authenticate) {
                                    await _post(createVisitURL, visitBody).then(async () => {
                                        if (index === arr.length - 1) {
                                            await localStorage.setItem('UnsyncedPlannedVisitsCount', JSON.stringify(this.state.visitsCount));
                                            await localStorage.setItem('CheckedDoctors', JSON.stringify([]));
                                            localStorage.setItem('SpecialRequest', JSON.stringify([]));
                                            localStorage.setItem('ExpectedTime', JSON.stringify([]));
                                            if (!this.state.nextPrevDate) {
                                                this.props.history.push("./Plan")
                                            }
                                            else
                                                this.setState({ nextPrevDate: false, disableSave: false, loading: false });
                                        }
                                    })
                                }
                                else {
                                    await visits.push(visitBody);
                                    await this.setState({ visitsCount: this.state.visitsCount + 1 });
                                    console.log(this.state.visitsCount);
                                    if (index === arr.length - 1) {
                                        await localStorage.setItem('UnsyncedPlannedVisits', JSON.stringify(visits));
                                        await localStorage.setItem('UnsyncedPlannedVisitsCount', JSON.stringify(this.state.visitsCount));
                                        await localStorage.setItem('CheckedDoctors', JSON.stringify([]));
                                        await alert("You have " + this.state.visitsCount + " unsynced planned visits due to internet disconnection");
                                        if (!this.state.nextPrevDate)
                                            this.props.history.push("./Plan")
                                        else
                                            this.setState({ nextPrevDate: false, disableSave: false, loading: false });
                                    }
                                }
                            }
                            //else {
                            //    if (!this.state.nextPrevDate)
                            //        this.props.history.push("./Plan");
                            //}
                        })
                    }
                })
                if (!this.state.enterloop)
                    this.props.history.push("./Plan");
            }
            else {
                if (!this.state.nextPrevDate)
                    this.props.history.push("./Plan");
            }
        }
    }

    onSync = async () => {
        await this.setState({ disableSync: true });
        await Authenticate().then((response) => { this.setState({ authenticate: response }) });

        const visits = localStorage.getItem('UnsyncedPlannedVisits');
        await this.setState({ USVisits: JSON.parse(visits) });
        const createVisitURL = constantURI() + "/OdooController/CreateVisit"
        this.state.USVisits.map(async (visit, index, arr) => {
            if (this.state.authenticate && index === arr.length - 1) {
                await _post(createVisitURL, visit).then((response) => {
                    return response.json().then(async (data) => {
                        localStorage.setItem('UnsyncedPlannedVisitsCount', JSON.stringify(0));
                        localStorage.setItem('UnsyncedPlannedVisits', JSON.stringify([]));
                        alert("Synced Successfully");
                        this.props.history.push("./Plan");
                    })
                })
            }
            else if (!this.state.authenticate && index === arr.length - 1) {
                alert("Only sync when connected to the Internet!");
                await this.setState({ disableSync: false });
            }
        })
    }

    closeAlert = () => {
        this.setState({ showAlert: false });
    }

    showAlert = () => {
        this.setState({ showAlert: true });
    }

    onCancelReason = async (e) => {
        await this.setState({ cancelReason: e.target.value });
    }

    onConfirm = async () => {
        await Authenticate().then((response) => { this.setState({ authenticate: response }) });
        await this.setState({ loading: true });

        var visits = (this.state.USPvisits === null || this.state.USPvisits === []) ? [] : this.state.USPvisits;
        const createVisitURL = constantURI() + "/OdooController/CreateVisit"
        const visitBody = {
            jsonrpc: "2.0",
            params: {
                method: "create",
                model: "calendar.event",
                args: [
                    {
                        name: "Cancel Day: " + this.state.cancelReason + " (" + this.state.rep + ")",
                        start: this.state.dateISO,
                        start_date: this.state.dateISO,
                        start_datetime: this.state.dateISO + " 05:00:00",
                        stop: this.state.dateISO,
                        stop_date: this.state.dateISO,
                        stop_datetime: this.state.dateISO + " 06:00:00",
                        duration: 0.00,
                        x_status: "3",
                        partner_ids: [this.state.currentRep[0].id],
                        x_cancelreason: this.state.cancelReason,
                    }
                ],
                "kwargs": {}
            },
            "token": this.state.token
        }
        if (this.state.authenticate) {
            await _post(createVisitURL, visitBody).then((response) => {
                return response.json().then(async (data) => {
                    await localStorage.setItem('UnsyncedPlannedVisitsCount', JSON.stringify(this.state.visitsCount));
                    await localStorage.setItem('CheckedDoctors', JSON.stringify([]));
                    await this.setState({ loading: false });
                })
            })
        }
        else {
            await visits.push(visitBody);
            await this.setState({ visitsCount: this.state.visitsCount + 1 });
            await localStorage.setItem('UnsyncedPlannedVisits', JSON.stringify(visits));
            await localStorage.setItem('UnsyncedPlannedVisitsCount', JSON.stringify(this.state.visitsCount));
            await localStorage.setItem('CheckedDoctors', JSON.stringify([]));
            await this.setState({ loading: false });
            await alert("You have " + this.state.visitsCount + " unsynced planned visits due to internet disconnection");
        }


        const d = new Date(this.state.date);
        d.setDate(d.getDate() + 1);
        let result = d.toLocaleDateString("fr-CA", { year: "numeric", month: "2-digit", day: "2-digit" });
        await this.setState({ date: d.toDateString(), dateISO: result });
        localStorage.setItem('RouteDate2', JSON.stringify(this.state.date));
        localStorage.setItem('RouteDate2', JSON.stringify(this.state.dateISO));
        this.closeAlert();
    }

    onPrevious = async () => {
        await this.setState({ disableSave: true, isNextOrPrev: true });
        if (this.state.date.substring(0, 4) === "Sat" || this.state.date.substring(0, 4) === "Sun") {
            const d = new Date(this.state.date);
            await d.setDate(d.getDate() - 1);
            let result = d.toLocaleDateString("fr-CA", { year: "numeric", month: "2-digit", day: "2-digit" });
            await this.setState({ date: d.toDateString(), dateISO: result })
            await localStorage.setItem('RouteDate2', JSON.stringify(this.state.date));
            await localStorage.setItem('RouteDate2', JSON.stringify(this.state.dateISO));
            await this.setState({ disableSave: false, isNextOrPrev: false });
        }
        else {
            const checkedDoctors = await localStorage.getItem('CheckedDoctors');
            await this.setState({ checked: JSON.parse(checkedDoctors) });
            if (this.state.checked.length !== 0) {
                await this.setState({ loading: true });
                await this.setState({ nextPrevDate: true });
                await this.onSave();
                const d = new Date(this.state.date);
                d.setDate(d.getDate() - 1);
                let result = d.toLocaleDateString("fr-CA", { year: "numeric", month: "2-digit", day: "2-digit" });
                await this.setState({ date: d.toDateString(), dateISO: result });
                await localStorage.setItem('RouteDate2', JSON.stringify(this.state.date));
                await localStorage.setItem('RouteDate2', JSON.stringify(this.state.dateISO));
                alert("This route has been saved succesfully");
                await this.setState({ disableSave: false, isNextOrPrev: false });
            }
            else {
                alert("You have selected 0 HCP! You should select a minimum of 1 for your route");
                await this.setState({ disableSave: false, isNextOrPrev: false });
            }
        }
    }

    onNext = async () => {
        await this.setState({ disableSave: true, dayCount: this.state.dayCount + 1, isNextOrPrev: true });
        if (this.state.date.substring(0, 4) === "Sat" || this.state.date.substring(0, 4) === "Sun") {
            const d = new Date(this.state.date);
            await d.setDate(d.getDate() + 1);
            let result = d.toLocaleDateString("fr-CA", { year: "numeric", month: "2-digit", day: "2-digit" });
            await this.setState({ date: d.toDateString(), dateISO: result })
            await localStorage.setItem('RouteDate2', JSON.stringify(this.state.date));
            await localStorage.setItem('RouteDate2', JSON.stringify(this.state.dateISO));
            await this.setState({ disableSave: false, isNextOrPrev: false });
        }
        else {
            const checkedDoctors = await localStorage.getItem('CheckedDoctors');
            await this.setState({ checked: JSON.parse(checkedDoctors) });
            if (this.state.checked.length !== 0) {
                await this.setState({ loading: true });
                await this.setState({ nextPrevDate: true });
                await this.onSave();
                const d = new Date(this.state.date);
                await d.setDate(d.getDate() + 1);
                let result = d.toLocaleDateString("fr-CA", { year: "numeric", month: "2-digit", day: "2-digit" });
                await this.setState({ date: d.toDateString(), dateISO: result })
                await localStorage.setItem('RouteDate2', JSON.stringify(this.state.date));
                await localStorage.setItem('RouteDate2', JSON.stringify(this.state.dateISO));
                alert("This route has been saved succesfully");
                await this.setState({ disableSave: false, isNextOrPrev: false });
            }
            else {
                alert("You have selected 0 HCP! You should select a minimum of 1 for your route");
                await this.setState({ disableSave: false, isNextOrPrev: false });
            }
        }
    }

    render() {
        return (
            <div style={stylesMed.mainBackgroundColor}>
                {(this.state.visitsCount === 0 || this.state.visitsCount === null) ?
                    <div className="alert alert-secondary">You have 0 planned visits to sync with Odoo.</div> :
                    <div className="col alert alert-danger">You have {this.state.visitsCount} planned visits to sync with Odoo.
                          <div className="row">
                            <h5 className="col-sm-8">Only sync when connected to the Internet!</h5>
                            <div className="col-sm-4 d-flex flex-row-reverse">
                                <div className={(this.state.disableSync) ? "btn disabled" : "btn"} style={stylesMed.wideButton} onClick={this.onSync}>Sync Planned Visits</div>
                            </div>
                        </div>
                    </div>
                }
                {(!this.state.alertUndefined) ?
                    null :
                    <div className="col alert alert-danger">
                        <div className="row">
                            <h6 className="col-sm-8">There seems to be a problem.</h6>
                            <div className="col d-flex flex-row-reverse">
                                <div className={(this.state.disableSync) ? "btn disabled" : "btn"} style={stylesMed.wideButton} onClick={() => window.location.reload()}>
                                    Reload</div>
                            </div>
                        </div>
                    </div>
                }
                <ArrowBackCircle className="btn" onClick={() => this.props.history.push("/Plan")} color={'#00bfff'} height="50px" width="50px" />
                <div className="pt-3 row">
                    <div className="col m-1 d-flex justify-content-start">
                        <div className="btn" style={stylesMed.wideButton} onClick={this.showAlert}>Skip Date</div>
                    </div>
                    <div className="col m-1 d-flex flex-row-reverse">
                        <div className={(this.state.disableSave) ? "btn disabled" : "btn"} style={stylesMed.wideButton} onClick={this.onSave}>Save Route</div>
                    </div>
                </div>
                <Modal show={this.state.showAlert} onHide={this.closeAlert} animation={false}>
                    <Modal.Header>
                        <Modal.Title>Are you sure you want to cancel the route?</Modal.Title>
                    </Modal.Header>
                    <Modal.Body><div>
                        <select className="col-sm-6 form-control" id="sel1" value={this.state.cancelReason} onChange={this.onCancelReason}
                            style={stylesMed.reportClientInput}>
                            <option value=""></option>
                            <option value="Travelling">Travelling</option>
                            <option value="No see today">No see today</option>
                            <option value="Meeting office">Meeting office</option>
                            <option value="Schedule conflict">Schedule conflict</option>
                        </select>
                    </div></Modal.Body>
                    <Modal.Footer>
                        <div className="btn" data-toggle="modal" data-target="#myModal" style={stylesMed.wideButton} onClick={this.onConfirm}>Confirm</div>
                        <div className="btn btn-secondary" data-toggle="modal" data-target="#myModal" style={stylesMed.cancelWideButton}
                            onClick={this.closeAlert}>Cancel</div>
                    </Modal.Footer>
                </Modal>
                <div className="pt-3 row" style={stylesMed.mainBackgroundColor}>
                    <div className="col">
                        <ArrowBackOutline className="btn" color={'#00bfff'} height="50px" width="50px" onClick={() => this.onPrevious()} />
                        <h6>Previous Date</h6>
                    </div>
                    <div className="col d-flex align-items-center justify-content-center">
                        <h5 style={stylesMed.routeDate}>Add Route: {this.state.date}</h5>
                    </div>
                    <div className="col" style={stylesMed.rightDirection}>
                        <ArrowForwardOutline className="btn" color={'#00bfff'} height="50px" width="50px" onClick={() => this.onNext()} />
                        <h6>Next Date</h6>
                    </div>
                </div>
                {(this.state.loading) ?
                    <div className="pt-3 text-center">
                        <div className="spinner-border" style={stylesMed.spinner}></div>
                    </div>
                    : <div style={stylesMed.mainBackgroundColor}>
                        <HCPs className="m-2" addRoute={true} history={this.props.history}></HCPs>
                    </div>
                }
            </div>
        );
    }
}